import React from 'react';
import PropTypes from 'prop-types';

import theme from './GenerateDocumentPopup.scss';
import BaseComponent from 'common/BaseComponent';
import Popup from 'common/Popup';
import Select from 'common/Select';
import {getMessage as msg} from 'MessageBundle';
import conf from 'configuration.json';

export default class GenerateDocumentPopup extends BaseComponent {

    state = {
        selectedOption: 'hvo',
        selectedTemplate: '',
        documentTemplates: []
    };
    
    componentDidMount() {
        this.request('get', conf.rest.documentTemplateEndpoint).send((result) => {
            this.setState({
                documentTemplates: result.body.userTemplates.filter(t => t.active)
            });
        });

        if (this.props.uvoAvailable) {
            this.voRadio.focus();
        } else {
            this.templateSelect.focus();
        }
    }

    generateTemplate = () => {
        const documentTemplateId = this.state.documentTemplates.find(t => t.name === this.state.selectedTemplate).id;
        this.props.onGenerateTemplate(documentTemplateId, this.state.selectedOption === 'hvo');
    };

    render() {
        const documentTemplates = new Map(this.state.documentTemplates.map(t => [t.name, t.displayableName]));
        return (
            <Popup visible={true}>
                <div className={theme.popupContent}>
                    <h2>{msg('documentTab.selectTemplate.popupHeader')}</h2>
                    <div>
                        <div className={theme.selectTemplate}>
                            <h3>{msg('documentTab.selectTemplate.voHeader')}<span>*</span></h3>
                            <div className={theme.radioWrap}>
                                <input id="hvo-radio" name="vo" type="radio" value="hvo"
                                    onChange={this.handleChange('selectedOption')} disabled={!this.props.uvoAvailable}
                                    checked={this.state.selectedOption === 'hvo'} ref={(voRadio) => this.voRadio = voRadio}/>
                                <label htmlFor="hvo-radio">
                                    {msg('documentTab.selectTemplate.hvoLabel')}
                                </label>
                            </div>
                            <div className={theme.radioWrap}>
                                <input id="uvo-radio" name="vo" type="radio" value="uvo"
                                    onChange={this.handleChange('selectedOption')} disabled={!this.props.uvoAvailable}
                                    checked={this.state.selectedOption === 'uvo'}/>
                                <label htmlFor="uvo-radio">
                                    {msg('documentTab.selectTemplate.uvoLabel')}
                                </label>
                            </div>
                        </div>

                        <Select id="documentTemplate-select" value={this.state.selectedTemplate} options={documentTemplates}
                            label={msg('documentTab.selectTemplate.documentTypeLabel')} onChange={this.handleChange('selectedTemplate')} size={9}
                            className={theme.selectDocumentType} ref={(templateSelect) => this.templateSelect = templateSelect}/>

                        <div className={theme.btnGroup}>
                            <span><span>*</span>{msg('documentTab.selectTemplate.mandatoryInfo')}</span>
                            <button id="cancel-btn" onClick={this.props.onClose}>
                                {msg('documentTab.selectTemplate.closeBtn')}
                            </button>
                            <button id="submit-btn" onClick={this.generateTemplate} disabled={this.state.selectedTemplate === ''}
                                title={msg('documentTab.selectTemplate.submitBtnTitle')}>
                                {msg('documentTab.selectTemplate.submitBtn')}
                            </button>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }
}

GenerateDocumentPopup.propTypes = {

    /**
     * JavaScript function that has to be invoked on close button click.
     */
    onClose: PropTypes.func.isRequired,

    /**
     * JavaScript function that has to be invoked on Generate Template button click.
     * It accepts next arguments: documentTemplate, hvo.
     */
    onGenerateTemplate: PropTypes.func.isRequired,

    /**
     * Specifies that UVO can be chosen.
     */
    uvoAvailable: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/EditComplaint/DocumentTab/GenerateDocumentPopup/index.js